var StolenFocus = [];

$(document).on('show', '.modal:not(.visible)', function() {
  var $this = $(this),
      id = $this.attr('id');
  StolenFocus[id] = document.activeElement;
  $this.addClass('visible').focus();
});

$(document).on('hide', '.modal.visible', function() {
  var $this = $(this),
      id = $this.attr('id'),
      stolen = StolenFocus[id];
  $this.removeClass('visible');
  if (stolen) {
    stolen.focus();
  }
});

$(document).on('keydown', '.modal.visible', function(e) {
  if (e.key == 'Escape') {
    $(this).trigger('hide');
  }
});

$(document).on('keydown', '.modal.visible', function(e) {
  if (e.key == 'Tab') {
    var $this = $(this),
        $focusable = $(':focusable:visible', $this),
        $first = $focusable.first(),
        $last = $focusable.last();
    // shift is also selected, aka navigating upwards
    if (e.shiftKey && ($first.is(':focus') || $this.is(':focus'))) {
      $last.focus();
      e.preventDefault();
    }
    // shift is not also selected, aka navigating downwards
    else if (!e.shiftKey && $last.is(":focus")) {
      $first.focus();
      e.preventDefault();
    }
  }
});